import _ from 'lodash';

export const vendorDeptHeaders = [
    { id: 'YS', name: '매출액', val: 'YS' },//Year Sales
    { id: 'CS', name: '매출완료액(세금계산서 완료)', val: 'CS' },//Completed Sales
    { id: 'ES', name: '매출예정액', val: 'ES' },//ESTIMATE SALES
];

export const vendorDeptHeaderTyps = [
    { id: 'sales', name: '매출액' },
    { id: 'purchase', name: '매입액' },
    { id: 'profitPrice', name: '매출이익' },
    { id: 'profit', name: '이익률' },
];



//rowSpan계산
const vendorData = [
    {
        id: 'v1', name: '메리츠캐피탈', children: [{
            id: 'p1', name: '메리츠캐피탈',
        }],
    },
    {
        id: 'v2', name: '서경대학교', children: [{
            id: 'p1', name: '서경대학교',
        }],
    },
    {
        id: 'v3', name: '웰컴페이먼츠', children: [
            {
                id: 'p1', name: '웰컴페이먼츠',
            },
            {
                id: 'p2', name: '웰컴페이',
            }


        ],
    },

];


export const makeDataVendorDeptStat = () => {
    vendorData.map((vendor) => {
        return vendor.children.map((partner) => {
            return vendorDeptHeaders.map((imp) => {
                let priceData = {
                    sales: `${Math.floor(Math.random() * 1000000000)}`,
                    purchase: `${Math.floor(Math.random() * 1000000000)}`,
                    profitPrice: `${Math.floor(Math.random() * 1000000000)}`,
                    profit: `${_.random(1, 100)} %`
                }
                partner[imp.val] = priceData;
            })
        })
    })
    return Array.from(vendorData);
}